export default "__VITE_PUBLIC_ASSET__0f82d73d__"